







































































































export default {
	name: 'expand',
	inject: ['responsive'],
	props: {
		numeroexpand: {
			type: Number,
			required: true,
		},
		codcomexpand: {
			type: Number,
			required: true,
		},
		codtalexpand: {
			type: Number,
			required: true,
		},
		totales: {
			type: Object,
		},
		method: {
			type: Function,
		},
		loadConfig: {
			type: Object,
		},
		type: {
			type: String,
		},
	},
	data() {
		return {
			loadingExpand: false,
			numeroexpand2: this.numeroexpand,
			codcomexpand2: this.codcomexpand,
			codtalexpand2: this.codtalexpand,
			contrato: this.type === 'contrato' ? true : false,
			gray: true,
			tableExpand: [],
		};
	},
	computed: {
		allTableData() {
			return this.$store.state.expand.allTableData;
		},
	},
	methods: {
		checkRow(row) {
			return this.numeroexpand2 == row.numero && this.codtalexpand2 == row.codtal && this.codcomexpand2 == row.codcom;
		},
		cellClass() {
			return this.responsive.isMobile ? 'labelMobile' : '';
		},
		showDetails(row): void {
			const found = this.allTableData.find(element => element.numpre === row.numpre);
			if (found) this.method(found);
		},
		tableRowClassName({ row, rowIndex }): string {
			let bg,
				clase = '';
			if (rowIndex === 0) {
				bg = 'bgGray';
				this.gray = true;
			}
			if (this.tableExpand[rowIndex - 1] && this.tableExpand[rowIndex - 1].fecha !== row.fecha) {
				//this.gray = !this.gray;
				bg = this.gray ? 'bgGray' : '';
			}
			if (this.tableExpand[rowIndex - 1] && this.tableExpand[rowIndex - 1].fecha === row.fecha) return this.gray ? 'bgGray' : '';
			else if (this.tableExpand[rowIndex + 1] && this.tableExpand[rowIndex + 1].fecha === row.fecha) clase = `sacarBorde ${bg}`;
			else clase = `bordeArriba ${bg}`;

			return clase;
		},
		load(): void {
			this.loadingExpand = true;
			let config = {
				url: this.contrato ? './api/public/proxy/cgi/etenet_contrapaq' : './api/public/proxy/cgi/etenet_fichapaq',
				data: {
					params: {
						codcom: this.codcomexpand,
						codtal: this.codtalexpand,
						numero: this.numeroexpand,
					},
				},
				contrato: this.contrato,
			};
			this.$store.dispatch('loadExpand', config).then(response => {
				this.tableExpand = response.data.items;
				this.loadingExpand = false;
			});
		},
		rowClassExpand(row, rowIndex): string {
			if (row.numero === this.numeroexpand && row.codcom === this.codcomexpand && row.codtal === this.codtalexpand) return 'bold';
			else return '';
		},
		getSummaries(param): Object {
			const { columns, data } = param;
			const sums: string[] = [];
			if (this.contrato) {
				columns.forEach((column, index) => {
					if (index === 3) {
						sums[index] = 'TOTAL';
						return;
					}
					if (index > 3) {
						const values = data.map(item => Number(item[column.property]));
						if (!values.every(value => isNaN(value))) sums[index] = this.totales[column.property];
						else sums[index] = '';
					}
				});
			}
			return sums;
		},
	},
	mounted() {
		switch (this.type) {
			case 'contrato':
				this.contrato = true;
				break;
			default:
				break;
		}
		this.load();
	},
};
